import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="bg-background-50 border-b border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-4">
        <div className="flex items-center gap-2 overflow-x-auto pb-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-4 py-2 rounded-full border border-background-200/70 text-sm font-medium text-foreground-600 hover:text-primary-600 hover:border-primary-300 hover:bg-primary-50/50 transition-all whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-xs`}></i>
              </div>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}